export interface EnvelopeStrategy {
  key: string;
  extract(response: unknown): unknown;
  wrap(fields: Record<string, unknown>): unknown;
  extractErrors?(response: unknown): unknown[];
}

export class FlatEnvelopeStrategy implements EnvelopeStrategy {
  key = "flat";
  extract(response: unknown): unknown { return response; }
  wrap(fields: Record<string, unknown>): unknown { return { ...fields }; }
}

export class DataOceanEnvelopeStrategy implements EnvelopeStrategy {
  key = "data-ocean";
  extract(response: any): unknown {
    if (!response) return null;
    return response?.body?.data?.data;
  }
  wrap(fields: Record<string, unknown>): unknown {
    return { data: { data: { ...fields } } };
  }
  extractErrors(response: any): unknown[] {
    if (!response?.body?.data?.errors) return [];
    return Array.isArray(response.body.data.errors) ? response.body.data.errors : [];
  }
}

export class EnvelopeStrategyRegistry {
  private static instance: EnvelopeStrategyRegistry;
  private strategies = new Map<string, EnvelopeStrategy>();

  private constructor() {
    this.register(new FlatEnvelopeStrategy());
    this.register(new DataOceanEnvelopeStrategy());
  }

  static getInstance(): EnvelopeStrategyRegistry {
    if (!EnvelopeStrategyRegistry.instance) {
      EnvelopeStrategyRegistry.instance = new EnvelopeStrategyRegistry();
    }
    return EnvelopeStrategyRegistry.instance;
  }

  register(strategy: EnvelopeStrategy, options?: { override?: boolean }): void {
    if (this.strategies.has(strategy.key) && !options?.override) {
      throw new Error(`Strategy "${strategy.key}" already registered`);
    }
    this.strategies.set(strategy.key, strategy);
  }

  resolve(protocolValue: string): EnvelopeStrategy {
    const strategy = this.strategies.get(protocolValue);
    if (!strategy) {
      throw new Error(`Unknown envelope protocol: ${protocolValue}`);
    }
    return strategy;
  }

  list(): EnvelopeStrategy[] {
    return Array.from(this.strategies.values());
  }
}
